import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import RootLayout from '@/layouts/RootLayout';
var leapGenBurg = {
  path: '/leapGenBurg',
  component: RootLayout,
  redirect: '/leapGenBurg/index',
  children: [{
    path: '/leapGenBurg/home',
    name: 'leapGenBurgHome',
    component: function component() {
      return import('@/views/leapGenBurg/Home');
    },
    meta: {
      title: '飞跃源堡'
    }
  }, {
    path: '/leapGenBurg/StartGame',
    name: 'StartGame',
    component: function component() {
      return import('@/views/leapGenBurg/StartGame');
    },
    meta: {
      title: '飞跃源堡'
    }
  }, {
    path: '/leapGenBurg/index',
    name: 'leapGenBurg',
    component: function component() {
      return import('@/views/leapGenBurg/Index');
    },
    meta: {
      title: '飞跃源堡'
    }
  }, {
    path: '/leapGenBurg/selectShip',
    name: 'leapGenBurgSelectShip',
    component: function component() {
      return import('@/views/leapGenBurg/SelectShip');
    },
    meta: {
      title: '选择飞船和引擎'
    }
  }, {
    path: '/leapGenBurg/skillCards',
    name: 'leapGenBurgSkillCards',
    component: function component() {
      return import('@/views/leapGenBurg/SkillCards');
    },
    meta: {
      title: '装备库'
    }
  }]
};
export default leapGenBurg;